'use strict';

var TNRoomSlider = (function () {

  var _initialised = {};

  function init(sectionId) {

    if (_initialised[sectionId]) return;
    _initialised[sectionId] = true;

    var wrap    = document.getElementById('tnnursery-room-wrap-' + sectionId);
    var track   = document.getElementById('tnnursery-room-track-' + sectionId);
    var prevBtn = document.getElementById('tnnursery-room-prev-' + sectionId);
    var nextBtn = document.getElementById('tnnursery-room-next-' + sectionId);
    var dotsEl  = document.getElementById('tnnursery-room-dots-' + sectionId);

    if (!wrap || !track) return;

    var slides      = Array.prototype.slice.call(track.querySelectorAll('.tnnursery-room-slide'));
    var totalSlides = slides.length;
    var currentIndex = 0;
    var slideW       = 0;

    // ── drag state ───────────────────────────────────────────────
    var dragStartX  = 0;
    var dragStartY  = 0;
    var dragDeltaX  = 0;
    var dragging    = false;
    var dragLocked  = false;
    var baseOffset  = 0;

    // ── helpers ──────────────────────────────────────────────────
    function getVisibleCount() {
      var w = window.innerWidth;
      if (w <= 768)  return 1;
      if (w <= 1024) return 3;
      return 4;
    }

    function maxIndex() {
      return Math.max(0, totalSlides - getVisibleCount());
    }

    function measureSlide() {
      if (!slides[0]) return;
      var gap = window.innerWidth <= 768 ? 12 : 16;  // 12px mobile gap (original)
      slideW  = slides[0].offsetWidth + gap;
    }

    function setTrack(px, animate) {
      track.style.transition = animate
        ? 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';
      track.style.transform = 'translateX(' + (-px) + 'px)';
    }

    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex()));
      baseOffset   = slideW * currentIndex;
      setTrack(baseOffset, true);
      updateDots();
      updateArrows();
    }

    // ── dots ─────────────────────────────────────────────────────
    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      var count = maxIndex() + 1;
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.className = 'tnnursery-room-dot' + (i === 0 ? ' tnnursery-room-dot--active' : '');
        btn.setAttribute('data-index', i);
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (idx) {
          btn.addEventListener('click', function () { goToSlide(idx); });
        }(i));
        dotsEl.appendChild(btn);
      }
    }

    function updateDots() {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.tnnursery-room-dot').forEach(function (dot, i) {
        var active = i === currentIndex;
        dot.classList.toggle('tnnursery-room-dot--active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }

    function updateArrows() {
      if (prevBtn) prevBtn.toggleAttribute('disabled', currentIndex <= 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', currentIndex >= maxIndex());
    }

    // ── arrow clicks ──────────────────────────────────────────────
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation(); measureSlide(); goToSlide(currentIndex - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation(); measureSlide(); goToSlide(currentIndex + 1);
    });

    // ── touch drag ────────────────────────────────────────────────
    wrap.addEventListener('touchstart', function (e) {
      measureSlide();
      dragStartX = e.touches[0].clientX;
      dragStartY = e.touches[0].clientY;
      dragDeltaX = 0;
      dragging   = false;
      dragLocked = false;
      baseOffset = slideW * currentIndex;
    }, { passive: true });

    wrap.addEventListener('touchmove', function (e) {
      if (dragLocked) return;

      var dx = dragStartX - e.touches[0].clientX;
      var dy = dragStartY - e.touches[0].clientY;

      if (!dragging) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          dragLocked = true;   // vertical scroll — release to browser
          return;
        }
        dragging = true;
      }

      e.preventDefault();   // block page scroll for horizontal drag

      dragDeltaX = dx;
      var liveOffset = baseOffset + dragDeltaX;

      // rubber-band resistance at edges
      var min = 0;
      var max = slideW * maxIndex();
      if (liveOffset < min) liveOffset = min - (min - liveOffset) * 0.25;
      if (liveOffset > max) liveOffset = max + (liveOffset - max) * 0.25;

      setTrack(liveOffset, false);
    }, { passive: false });

    wrap.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging   = false;
      dragLocked = false;

      var threshold = slideW * 0.2;

      var targetIndex = currentIndex;
      if (dragDeltaX > threshold)       targetIndex = currentIndex + 1;
      else if (dragDeltaX < -threshold) targetIndex = currentIndex - 1;

      goToSlide(targetIndex);
    }, { passive: true });

    // ── resize ────────────────────────────────────────────────────
    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        measureSlide();
        goToSlide(0);
        buildDots();
      }, 150);
    });

    // ── init ──────────────────────────────────────────────────────
    // Deferred init.
    //
    // measureSlide() reads slides[0].offsetWidth, which forces a synchronous
    // layout. Running it during page load costs a reflow per slider, and on
    // sections using content-visibility: auto it also forces the browser to
    // lay out a subtree it would otherwise have skipped entirely.
    //
    // Nothing here is needed before the slider is near the viewport: at init
    // currentIndex is 0, so the track transform is translateX(0) regardless of
    // the measured width. Arrow clicks and touchstart re-measure on their own.
    function initSlider() {
      measureSlide();
      buildDots();
      updateArrows();
    }

    if ('IntersectionObserver' in window) {
      var initObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        initObserver.disconnect();
        initSlider();
      }, { rootMargin: '300px' });
      initObserver.observe(wrap);
    } else {
      initSlider();
    }
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="tnnursery-room-wrap-"]').forEach(function (el) {
    var sectionId = el.id.replace('tnnursery-room-wrap-', '');
    TNRoomSlider.init(sectionId);
  });
});